import {Injectable} from "@angular/core";
import { DataProviderFactory, DataRequest } from "app/provider/data2.provider";
import { BaseService } from "../views/base.service";
import { HttpClient } from "@angular/common/http";


@Injectable()
export class DomainsService extends BaseService {
	public actions: DataRequest;
	public zones: DataRequest;
	public expired: DataRequest;

	constructor(
		public dpf: DataProviderFactory,
		public http: HttpClient,
	) {
		super(http);
		
		this.actions = this.dpf.getNew('domain_actions');
		this.zones = this.dpf.getNew('domain_zones');
		this.expired = this.dpf.getNew('expired_domains');
	}
}
